<eda-dialog2 width="80vw" height="80vh" [header]="title" (apply)="saveChartConfig()" (close)="closeChartConfig()">
  <div content class="flex flex-col md:flex-row flex-1 overflow-hidden h-[65vh]">
    <!-- Chart Preview -->
    <div class="p-6 flex-1 flex items-center justify-center border-b md:border-b-0 md:border-r bg-slate-50">
      <div class="relative w-full max-w-xl aspect-square">
          <panel-chart #PanelChartComponent
            [props]="panelChartConfig"
            class="h-full w-full block"
          ></panel-chart>
      </div>
    </div>

    <!-- Settings -->
    <div class="p-6 flex-1 overflow-y-auto">
      <div class="space-y-6">
        <div class="space-y-4">
          <div class="space-y-4">
            <h1 class="font-medium text-slate-500 uppercase" i18n="@@chartDisplayOptionsTitle">
              Opciones de visualización
            </h1>
  
            <div class="flex items-center justify-between">
              <div class="space-y-0.5">
                <div class="flex flex-col gap-2">
                  <label i18n="@@Limits" class="font-medium">
                    Limites
                  </label>
                  <input type="number" [(ngModel)]="min" class="w-full border p-1 rounded" placeholder="min">
                  <input type="number" [(ngModel)]="max" class="w-full border p-1 rounded" placeholder="max">
                </div>
              </div>
            </div>
          </div>

          <h1 i18n="@@colorsChartH6" class="font-medium text-slate-500 uppercase">Colors</h1>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="flex items-center justify-between border rounded-lg p-3 hover:bg-slate-50">
              <span class="font-medium">{{ assignedColors[0]?.value }}</span>
              <div class="flex items-center gap-2">
                <input [(ngModel)]="assignedColors[0].color" (input)="handleInputColor()" class="text-md text-slate-500 font-mono w-[3.5vw]">
                <p-colorPicker [(ngModel)]="assignedColors[0].color" (onChange)="handleInputColor()" format="hex" appendTo="body" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</eda-dialog2>